import SituacionLaboralDelete from './SituacionLaboralDelete'
export {SituacionLaboralDelete}
export default SituacionLaboralDelete
